<template>
  <!-- begin panel -->
  <panel no-button="true" title="My Events">
    <div class="card-columns">
      <!-- begin create card -->
      <b-card no-body class="overflow-hidden">
        <b-row no-gutters>
          <b-col md="6">
            <img
              src="@/assets/images/create-new-event-logo.png"
              class="img-fluid card-image rounded-0"
            />
          </b-col>
          <b-col md="6">
            <b-card-body>
              <b-card-title>Create new event</b-card-title>

              <b-card-text class="mt-2">
                <url-button
                  class="btn-yellow"
                  label="Create new event"
                  :url="'/event/new/choices'"
                />
              </b-card-text>
            </b-card-body>
          </b-col>
        </b-row>
      </b-card>
      <!-- end create card -->

      <!-- begin event card -->
      <b-card
        no-body
        class="overflow-hidden"
        v-for="event in events"
        :key="event.id"
        v-bind:class="{
          'bg-gray-transparent-1': activeEvent && activeEvent.id == event.id,
          'bg-gray-transparent-4': !activeEvent || !(activeEvent.id == event.id)
        }"
      >
        <b-row no-gutters>
          <b-col md="6">
            <b-card-img
              :src="getImage(event)"
              alt="Event image"
              class="rounded-0"
            ></b-card-img>
          </b-col>
          <b-col md="6">
            <b-card-body>
              <b-card-title>{{ event.name }}</b-card-title>
              <b-card-sub-title v-if="event.startTime">
                {{ event.startTime | moment('DD.MM.YYYY') }} -
                {{ event.endTime | moment('DD.MM.YYYY') }}
              </b-card-sub-title>
              <b-card-text class="mt-2">
                <url-button
                  class="btn-inverse"
                  label="View"
                  :url="'/event/' + event.id"
                />
                <input-button
                  type="submit"
                  label="Select"
                  @click="selectEvent(event)"
                  class="btn-yellow"
                />
              </b-card-text>
            </b-card-body>
          </b-col>
        </b-row>
      </b-card>
    </div>
  </panel>
  <!-- end panel -->
</template>

<script>
import UrlButton from '../buttons/UrlButton.vue'
import InputButton from '../buttons/InputButton.vue'

export default {
  name: 'EventCards',
  props: ['events', 'activeEvent'],
  components: {
    UrlButton,
    InputButton
  },
  methods: {
    selectEvent(event) {
      this.$parent.setActive(event)
    },
    getImage(event) {
      if (event.image) {
        return (
          process.env.VUE_APP_API_URL + '/uploads/images/' + event.image.imageFd
        )
      } else {
        return require('../../assets/images/no_image.jpg')
      }
    }
  }
}
</script>
